import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../components/TourGuide';

/* eslint-disable react/prop-types */
export const SelectsFormat = ({
  renderTourGuide,
  showFormatModal,
  GenerateArtSteps,
  handleFinishTutorial,
  setShowFormatModal,
  selectedFormat,
  setSelectedFormat,
  formatOptions,
}) => {
  const { t } = useTranslation()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        position: 'relative',
      }}
    >

      <div
        onClick={() => {
          setShowFormatModal(!showFormatModal);
        }}
        id='format-selector'
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '10px 20px 10px 16px',
          gap: '10px',
          background: '#FFFFFF',
          border: '1px solid #EBE6F5',
          borderRadius: '12px',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            width: '18px',
            height: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width:
                selectedFormat?.value === 'vertical'
                  ? '8px'
                  : selectedFormat?.value === 'horizontal'
                    ? '16px'
                    : '12px',
              height:
                selectedFormat?.value === 'vertical'
                  ? '12px'
                  : selectedFormat?.value === 'horizontal'
                    ? '8px'
                    : '12px',
              background: '#0D0521',
              borderRadius: '4px',
            }}
          />
        </div>

        <span
          style={{
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '21px',
            color: '#414141',
          }}
        >
          {selectedFormat ? selectedFormat.label : t('new_publication_page_ia_format')}
        </span>
      </div>

      {showFormatModal && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            left: '0',
            right: '0',
            backgroundColor: '#F8F8F8',
            borderRadius: '12px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            padding: '8px',
            marginTop: '8px',
            zIndex: 1000,
            width: 370,
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
          }}
        >
          {formatOptions.map((option) => (
            <div
              key={option.id}
              onClick={() => {
                setSelectedFormat(option);
                setShowFormatModal(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '300px',
                height: '80px',
                flexDirection: 'column',
                gap: '6px',
                padding: '8px',
                cursor: 'pointer',
                borderRadius: '8px',
                transition: 'background-color 0.2s',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                }}
              >
                <div
                  style={{
                    width:
                      option.value === 'vertical'
                        ? '26px'
                        : option.value === 'horizontal'
                          ? '40px'
                          : '26px',

                    height:
                      option.value === 'vertical'
                        ? '40px'
                        : option.value === 'horizontal'
                          ? '26px'
                          : '26px',

                    backgroundColor:
                      selectedFormat?.value === option.value
                        ? '#4CAF50'
                        : '#B7B7B7',
                    borderRadius: '2px',
                  }}
                />
                <span
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    textAlign: 'center',
                  }}
                >
                  {option.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
